module.exports = __webpack_public_path__ + "sprites.8c36.png";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/sprites.png
// module id = ./src/_asset/sources/assets/images/sprites.png
// module chunks = main